'use client';
import { useEffect, useMemo, useState } from 'react';
import {
  requestCategoryProducts,
  requestGetStatus,
  requestProductByCategory,
} from '@/lib/api/goods-categories';
import { useRouter, useParams } from 'next/navigation';
import {
  GetStatusType,
  ProductByCategoryType,
} from '@/lib/type/product-center';
import ProductList from '@/app/product-center/[id]/[slug]/ProductList';
import ProductSelection from '@/app/product-center/[id]/[slug]/productSelection';
import { GetProductByCategory } from '@/lib/type/product.type';
import { Empty } from 'antd';
import Link from 'next/link';
import Loading from '@/components/loading';

export default function DataShow() {
  // 获取分类id
  const params = useParams();
  const cate_id = useMemo(() => {
    if (params.slug && typeof params.slug === 'string') {
      return params.slug;
    }
  }, [params]);

  // 加载状态
  const [loading, setLoading] = useState(true);

  // 分类下产品
  const [products, setProducts] = useState<ProductByCategoryType>();
  // 属性筛选
  const [status, setStatus] = useState<GetStatusType>();

  // 当前页数
  const [currentPage, setCurrentPage] = useState(1);
  // 默认每页可以显示多少条
  const [pageSize, setPageSize] = useState(5);
  // 当前页数 或 每条多少页 发生变化
  const pageChange = (current: number, size?: number) => {
    setCurrentPage(current);
    // antd 的 Pagination 在未开启 showSizeChanger 时可能不传 pageSize（size 为 undefined）
    if (typeof size === 'number' && size !== pageSize) {
      setPageSize(size);
    }
  };

  // 发送请求的参数
  const getProductParams = useMemo(() => {
    return {
      cate_id,
      per_page: pageSize + '',
      page: currentPage + '',
    };
  }, [cate_id, pageSize, currentPage]);

  // 根据分类id获取分类下产品
  const getProduct = async (getProductParams: GetProductByCategory) => {
    const res = await requestProductByCategory(getProductParams);
    setProducts(res.data);
    setLoading(false);
  };

  // 获取分类下用于筛选产品的属性
  const getStats = async () => {
    if (cate_id) {
      const res = await requestGetStatus({ id: cate_id });
      setStatus(res.data);
    }
  };

  // 参数发生变化发送请求获取产品数据
  useEffect(() => {
    setLoading(true);
    getProduct(getProductParams);
  }, [getProductParams]);

  useEffect(() => {
    getStats();
  }, []);

  return (
    <div className="container">
      {loading ? (
        <Loading />
      ) : (
        <div>
          {products?.list.length && products?.list.length > 0 ? (
            <>
              <ProductSelection status={status} />
              <ProductList
                products={products}
                currentPage={currentPage}
                pageSize={pageSize}
                pageChange={pageChange}
              />
            </>
          ) : (
            <div className="h-[500px] c-flex flex-col">
              <Empty />
              <Link href="/public" className="text-main text-2xl mt-6">
                <span className="underline">首页</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
